// extracted by mini-css-extract-plugin
module.exports = {"content":"trails-page_content__1sPED","cableWaysList":"trails-page_cableWaysList__0mWqx"};